import { IMapTooltip } from "../map/types"
import { Datalayer } from "./datalayer"
import { LayerEditMode } from "./types"

export function getTooltip(tooltip: IMapTooltip, filter: (layer: Datalayer) => boolean = null): boolean {

    if (!tooltip) return false
    if (!tooltip.feature) return false

    let layer = tooltip.feature.get("layer")

    if (layer instanceof Datalayer) {

        if (!layer.showTooltips) {
            return false
        }

        if (filter && (!filter(layer))) {
            return false
        }

        const data = tooltip.data
        if (!data) return false

        const editTarget = (layer.editMode == LayerEditMode.EditTarget)

        if ((!editTarget) || tooltip.contextMenu) {
            tooltip.template = layer.getTooltipTemplate(tooltip.feature, data, editTarget)
            return true
        }

    }

}
